<!--studentAnswer:学生答案页面 2024/01/23 16:53:29 XIJIGUO-->
<template>
  <div class="wrapper" v-loading="examLoading">
    <div class="menu-wrapper">
      <ul class="menu-list">
        <li v-for="(item, index) in menus" :key="`menu-${index}`" :class="curMenuName === item.tabName ? 'actived' : ''" data-io-click="tracker" @click="changeMenu(item)">
          <el-badge :value="item.count" class="badge" :hidden="item.count <= 0" style="z-index: 10">
            <span>{{ item.permName }}</span>
          </el-badge>
        </li>
      </ul>

      <div class="right-menu">
        <template v-if="curMenuName === 'StudentAnswer'">
          <template v-if="isReadWritePermission(2)">
            <el-popover placement="bottom" width="114" trigger="hover" popper-class="student-answer">
              <div>
                <ul>
                  <li v-for="(item, index) in moreMenus" :key="`export-${index}`" class="menu-li" :class="(item.menuIndex === 1 && isReadWritePermission(3)) || item.menuIndex !== 1 ? '' : 'disabled'" @click="changeMoreMenu(item)">
                    {{ item.permName }}
                  </li>
                </ul>
              </div>
              <span slot="reference" class="button">更多设置</span>
            </el-popover>
            <el-popover placement="bottom" width="114" trigger="hover" popper-class="student-answer">
              <div>
                <ul>
                  <li v-for="(item, index) in filteredExportMenus" :key="`export-${index}`" class="menu-li" @click="changeExportMenu(item)">
                    {{ item.permName }}
                  </li>
                </ul>
              </div>
              <span v-show="$store.state.backDoor || !(exam.isMore === 2)" class="round-button" slot="reference">
                <span>导出</span>
                <img src="~images/export.svg" style="fill:red" />
              </span>
            </el-popover>
          </template>
          <template v-else>
            <span class="button" style="color:#999999">更多设置</span>
            <span v-show="$store.state.backDoor || !(exam.isMore === 2)" class="round-button round-button-disabled">
              <span>导出</span>
              <img src="~images/export.svg" style="fill:red" />
            </span>
          </template>
        </template>
      </div>
    </div>
    <div class="content-wrapper" v-if="showContent">
      <header class="header-box">
        <div style="display: flex;justify-content:space-between;">
          <div style="display: flex; align-items: center;">
            <div class="back" @click="backAction">
              <img src="~images/back.png" width="10" />
              <span>返回</span>
            </div>
            <div class="exam-info">
              <span style="color: #919599;margin-right: 15px;">|</span>
              <div v-if="exam.subjectName" class="tool-subject">
                <span style="margin-bottom: 5px">{{ exam.subjectName.substr(0, 1) }}</span>
              </div>
              <span v-if="exam.examName" class="exam-name" :title="exam.examName">{{ exam.examName }}</span>
              <img src="~images/grade.png" width="16" style="margin: 0 10px 0 20px" />
              <span style="font-size: 14px;color: #606266">年级:</span>
              <span style="font-size: 14px;margin-left: 4px;color: #606266">{{ exam.gradeName }}</span>
            </div>
          </div>
          <div style="display: flex;">
            <p @click="downloadExe" class="download">
              下载客户端
              <img src="@/v3/modules/card_use/assets/images/download-icon.png" width="16px" />
            </p>
          </div>
        </div>
      </header>
      <router-view :exam-info="exam" @changeMenu="changeMenu" :schoolId.sync="schoolId" :resultId="resultId" :isRegion="isRegion" @refreshDoubt="getExamDoubt" :login-platform="loginPlatform" @changeSchool="changeSchool"></router-view>
    </div>
    <footer-bar></footer-bar>

    <!--导入学生成绩弹窗-->
    <yue-dialog title="导入学生成绩" width="500px" :visible.sync="importVisible" center custom-class="import-grades">
      <div class="dialog-content">
        <div v-loading="submitLoading">
          <el-upload ref="importUpload" :limit="1" accept=".xlsx,.xls" :action="getUploadUrl()" :data="uploadData" :headers="headers" :on-error="handleUploadError" :on-success="handleUploadSuccess" :on-change="handleUploadChange" :on-remove="handleUploadChange" :auto-upload="false" :file-list="importFileList" :multiple="false">
            <el-button type="primary" class="import-button" size="small" :disabled="!isPermission">
              <img src="~images/upLoad.svg" />
              导入学生成绩</el-button>
          </el-upload>
        </div>
        <div v-loading="pageLoading">
          <el-button type="text" @click="downloadStudentScoreTemp()" style="margin-top:16px">学生成绩模板下载</el-button>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="ifImportError" type="danger" size="medium" @click="downloadImportError" class="import-btn">下载错误信息</el-button>
        <el-button v-else class="upload-button" @click="handleSaveMarkStudent()" :loading="submitLoading">确定上传</el-button>
      </span>
    </yue-dialog>

    <!--编辑学生记录-->
    <yue-dialog title="编辑记录" :visible.sync="logVisible" center width="758px" custom-class="edit-log">
      <el-table :data="logList" v-loading="logLoading" style="width: 100%" header-row-class-name="header-log">
        <el-table-column prop="studName" align="center" label="姓名"></el-table-column>
        <el-table-column prop="studNo" align="center" label="考号"></el-table-column>
        <el-table-column align="center" label="题号">
          <template slot-scope="scope">
            {{ scope.row | standardQuestionNumber }}
          </template>
        </el-table-column>
        <el-table-column prop="teacherName" align="center" label="修改人"></el-table-column>
        <el-table-column prop="before" align="center" label="修改前"></el-table-column>
        <el-table-column prop="after" align="center" label="修改后"></el-table-column>
        <el-table-column prop="data" align="center" label="修改时间" width="130px"></el-table-column>
      </el-table>

      <div style="height: 50px;padding-top: 10px;" v-if="logPagination.total > 0">
        <zj-pagination @current-change="handleLogCurrentChange" :page="{ total: logPagination.total, current: 1 }"></zj-pagination>
      </div>
    </yue-dialog>

    <!--导出客观题分析-->
    <yue-dialog title="导出客观题分析" :visible.sync="problemAnalysisVisible" center width="700px">
      <export :schoolId="schoolId" :examId="examId" v-if="problemAnalysisVisible" :type-list="['TEACH_CLASS_OBJECTIVE_STATISTICS', 'CLASS_OBJECTIVE_STATISTICS', 'SCHOOL_OBJECTIVE_SCORE_DETAIL']" />
    </yue-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { domain } from "@/config";
import util from '@/v2/utils/util'
import examResultDetailTypeEnum from '@/utils/enums/examResultDetailTypeEnum';
import { getExam, getStudentScoreTemp, queryTaskProgress, getDistinguishLogList, exportStudent } from "@/api/exam/exam";
import ZjPagination from '@/pages/zujuan/components/ZjPagination.vue';
import Export from "@/pages/exam/single/problemExport";
import FooterBar from '@/v3/components/FooterBar'
import { examApi, mainApi } from '@/v2/utils/api'
import { magicApi } from '@/utils/magic'

export default {
  name: 'studentAnswer',
  components: {
    ZjPagination,
    Export,
    FooterBar
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    isPermission () {
      return (this.isRegion && this.userInfo.isAdmin) || !this.isRegion
    },
    headers: function () {
      return {
        Accept: 'application/json',
        token: YJ_SCHOOL_STORAGE.getItem('token')
      };
    },
    filteredExportMenus () {
      return this.exportMenus.filter(item => {
        return this.$store.state.backDoor || item.menuIndex < 2;
      });
    },
    loginPlatform () {
      return this.$store.state.v2.loginPlatform
    }
  },
  data () {
    return {
      isRegion: false,
      examId: this.$route.params.id,
      domain: domain,
      schoolId: 0,
      examLoading: false,
      exam: {
        id: 0,
        examCode: '0000000',
        examName: '未知考试',
        subjectName: '未知科目',
        gradeName: '未知年级'
      },
      menus: [
        { permName: "成绩管理", tabName: 'StudentView', count: 0, type: '1' },
        { permName: "扫描批次", tabName: 'ExamScanBatch', count: 0, type: '2' },
        { permName: "考生答题卡", tabName: 'StudentAnswer', count: 0, type: '2' },
        { permName: "疑问项批量处理", tabName: 'ExamBatchDoubt', count: 0, type: '0' },
      ],
      curMenuName: '',
      moreMenus: [
        { permName: "导入学生成绩", tabName: 'studentAchievements', menuIndex: 1 },
        { permName: "查看编辑记录", tabName: 'editRecord', menuIndex: 2 },
      ],
      exportMenus: [
        { permName: "客观题分析", tabName: 'objectiveQuestionAnalysis', menuIndex: 1, kind: 'StudentAnswer' },
        { permName: "未上传/无卡考生", tabName: 'noUpload', menuIndex: 2, kind: 'StudentAnswer' },
        { permName: "异常考生名单", tabName: 'studentRoster', menuIndex: 3, kind: 'StudentAnswer' },
        { permName: "获取原始成绩", tabName: 'studentScore', menuIndex: 4, kind: 'StudentAnswer' },
      ],

      showContent: false,
      pageLoading: false,
      importVisible: false,
      progressData: 0,
      uploadData: {},
      ifImportError: false,
      importFileList: [],
      importErrorUrl: "",
      submitLoading: false,

      logList: [],
      logVisible: false,
      logLoading: false,
      logPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },

      problemAnalysisVisible: false,
      resultId: '',
      paperCount: 0,
    }
  },
  mounted () {
    if (this.loginPlatform === 'region') {
      this.moreMenus = this.moreMenus.filter(item => item.tabName !== 'studentAchievements')
      this.exportMenus = this.exportMenus.filter(item => ['noUpload', 'studentRoster'].indexOf(item.tabName) > -1)
    }

    this.examLoading = true;
    this.curMenuName = this.$route.name;
    this.schoolId = this.$route.query.schoolId || this.userInfo.schoolId;
    this.uploadData = {
      schoolId: this.schoolId,
      examId: this.examId
    };
    this.getExamDoubt()
    this.initData();
  },
  beforeRouteUpdate (to, from, next) {
    this.curMenuName = to.name
    next()
  },
  methods: {
    downloadExe () {
      this.$root.$children[0].downloadExe()
    },
    getUploadUrl () {
      const newDate = new Date();
      return `${this.domain}/marking-exam-manager/student-score/excel/score?tempId=${this.examId}&time=${newDate.getTime()}`
    },
    // 初始化数据
    async initData () {
      let resp = await getExam(this.examId);
      if (resp.success && resp.body) {
        this.exam = resp.body
        this.exam.examName += `${this.exam.isAdd ? '（附加卷）' : ''}`
        this.exam.examName += `${this.exam.isTwo ? '（二卷）' : ''}`
        // 是否为区域统考，除有痕外都不可编辑
        if (this.exam.isMore === 2) {
          this.isRegion = true; // 是否为区域统考
        }

        // 有痕考试
        const importType = this.exam.importType + ''
        const index = importType === '1' ? '1' : '2'
        let menus = this.menus.filter(s => ['0', index].indexOf(s.type) > -1)
        if (importType === '2') {
          menus = menus.filter(s => s.tabName != 'ExamScanBatch')
        }
        this.menus = menus
        // 增加检测
        if (menus && menus.length > 0 && !menus.some(s => s.tabName === this.curMenuName)) {
          this.changeMenu(menus[0])
        }

        await this.getExamAuth()
      } else {
        this.$message.warning('获取考试信息失败，请重试！')
      }
      this.changeContentShow()
      this.examLoading = false;
    },
    async getExamAuth () {
      const params = { schoolId: this.userInfo.schoolId, ids: { EXAM: [this.examId] } }
      const resp = await mainApi.getExamPerms(params)
      if (resp && resp.body) {
        const perms = resp.body[this.examId] || []
        this.exam.permsDict = {
          perms,
          gradeId: [this.exam.bigGradeId],
          subjectCode: [this.exam.subjectCode],
          classId: [...this.exam.classIds, ...this.exam.teachClassIds]
        }
        const code = 'Answer-Sheet-Scan'
        util.setExamPermCache(code, this.examId, (perms.map(item => item.permCode) || []).includes(code))
      }
    },
    // 获取疑问项统计
    getExamDoubt () {
      examApi.getExamDoubt({ examId: this.examId, schoolId: this.schoolId, }).then(resp => {
        if (resp.success) {
          this.menus.forEach(item => {
            if (item.tabName === 'StudentAnswer') {
              item.count = resp.body.paperDoubtCount || 0
            } else if (item.tabName === 'ExamBatchDoubt') {
              item.count = resp.body.questionDoubtCount || 0
            }
          })
        } else {
          this.$message.warning(resp.message)
        }
      })
    },

    changeContentShow () {
      this.showContent = this.exam.id > 0
    },
    changeMenu (item) {
      if (this.curMenuName === item.tabName) {
        return
      }

      this.resultId = item.resultId ? item.resultId : ''
      this.curMenuName = item.tabName
      this.$router.replace({ name: this.curMenuName, query: { from: this.$route.query.from } })
    },
    // 下载学生成绩模板
    downloadStudentScoreTemp () {
      this.pageLoading = true
      getStudentScoreTemp({
        examId: this.examId,
        schoolId: this.schoolId
      }).then(res => {
        if (res.success && res.body) {
          window.open(res.body)
        } else {
          this.$message.warning(res.message)
        }
        this.pageLoading = false
      })
    },
    handleSaveMarkStudent () {
      if (this.importFileList && this.importFileList.length > 0) {
        this.submitLoading = true;
        this.$refs.importUpload.submit()
      } else {
        this.$message.warning('请先上传学生成绩')
      }
    },
    handleUploadSuccess (resp) {
      if (resp.success) {
        this.checkFileOperateStatus(resp.body);
      } else {
        this.$message.error("上传失败" + resp.message);
        this.submitLoading = false;
      }
    },
    // 轮询模板状态
    async checkFileOperateStatus (id) {
      const resp = await queryTaskProgress(id);
      if (resp.body) {
        if (resp.body.error) {
          // 导入失败
          this.$message.error(resp.body.message);
          this.importErrorUrl = resp.body.error;
          this.ifImportError = true;
          this.submitLoading = false;
          this.importFileList = [];
          this.progressData = 0
        }
        else if (resp.body.completed) {
          // 已结束
          this.progressData = 100
          this.$message.success(resp.body.message);
          this.importErrorUrl = "";
          this.importFinish();
        } else {
          // 处理中
          this.progressData = parseInt(resp.body.step / resp.body.total * 100)
          setTimeout(() => {
            this.checkFileOperateStatus(id);
          }, 2000);
        }
      } else {
        this.submitLoading = false;
      }
    },
    handleUploadError (err) {
      this.submitLoading = false;
      this.ifImportError = false;
      this.$message.error("上传失败" + err);
    },
    handleUploadChange (file, fileList) {
      this.ifImportError = false;
      this.importFileList = fileList;
    },
    importFinish () {
      this.submitLoading = false;
      this.importVisible = false;
      this.ifImportError = false;
      this.importFileList = [];
    },
    changeMoreMenu (item) {
      switch (item.menuIndex) {
        case 1:
          if (this.isReadWritePermission(3)) {
            this.importVisible = true
          }
          break;
        case 2:
          this.getLogList()
          break;
      }
    },
    async getLogList () {
      this.logList = [];
      this.logVisible = true;
      let params = {
        examId: this.examId,
        schoolId: this.schoolId,
        currentPage: this.logPagination.currentPage,
        pageSize: 10
      };

      this.logLoading = true;
      let resp = await getDistinguishLogList(params);
      this.logLoading = false;

      if (resp.body) {
        for (let item of resp.body.items) {
          item.data = util.formatDate(item.createTime, 'ymdhi')
          item.studNo = item.studentVo ? item.studentVo.studNo : '';
          switch (item.type) {
            case examResultDetailTypeEnum.PAPER.name:
              item.typeName = "班级学号";
              break;
            case examResultDetailTypeEnum.CHOICE.name:
            case examResultDetailTypeEnum.MULTI_CHOICE.name:
              item.typeName = "客观题";
              break;
            case examResultDetailTypeEnum.SUBJECTIVE.name:
              item.typeName = "主观题";
              break;
          }
        }

        this.logList = resp.body.items
      }

      this.logPagination.total = resp.body.totalSize;
    },
    handleLogCurrentChange (val) {
      this.logPagination.currentPage = val;
      this.getLogList();
    },
    changeExportMenu (item) {
      switch (item.menuIndex) {
        case 1:
          if (this.examSign == "1") {
            this.$message.warning('该场考试报告已生成，请到"考试报告"中下载')
          } else {
            this.problemAnalysisVisible = true
          }
          break;
        case 2:
          this.exportStudent('UN_UPLOAD')
          break;
        case 3:
          this.$router.push({
            path: '/tem/download', query: {
              examId: this.examId,
              title: this.exam.examName,
              type: 'abnormalTestPaper'
            }
          })
          break;
        case 4:
          magicApi.downloadExamResult(this.examId, this.schoolId, true).then(resp => {
            if (resp.body) {
              this.checkLongTask(resp.body)
            } else {
              this.$message.error(resp.message)
            }
          })
          break;
      }
    },
    // 导出学生名单
    exportStudent (type) {
      const params = {
        examId: this.examId,
        schoolId: this.schoolId,
        type
      }
      exportStudent(params).then(resp => {
        if (resp.body) {
          window.open(resp.body, "_blank");
        }
      })
    },
    downloadImportError () {
      window.open(this.importErrorUrl);
    },
    checkLongTask (id) {
      magicApi.checkLongTask(id).then(resp => {
        if (resp.body.completed) {
          window.open(resp.body.message, '_blank')
        } else {
          setTimeout(() => {
            this.checkLongTask(id)
          }, 1 * 1000);
        }
      })
    },
    // 读写权限 type: 1:无权限  2：读权限 3：写权限
    isReadWritePermission (type = 2) {
      return (this.loginPlatform === 'school' && ((this.isRegion && this.exam.scorePermission >= type) || !this.isRegion)) || this.loginPlatform === 'region'
    },
    backAction () {
      if (this.$route.query.from === 'quick') {
        this.$router.push({ path: '/v2/exam/index' })
      } else {
        this.$router.back()
      }
    },
    changeSchool (schoolId) {
      if (this.schoolId != schoolId) {
        this.schoolId = schoolId
      }
    },
  },
  filters: {
    standardQuestionNumber (val) {
      if (util.isEmpty(val)) {
        return '--'
      }
      return util.standardQuestionNumber(val);
    }
  },
}
</script>
<style scoped lang="scss">
.wrapper .header-wrapper {
  height: 88px;
  background: #fff;
  padding: 0 calc(50% - 600px);
  display: flex;
}

.wrapper .header-wrapper .logo {
  padding-top: 20px;
  width: 106px;
}

.wrapper .header-wrapper .header {
  position: relative;
  text-align: center;
  flex: 1;
  margin-top: 20px;
}

.wrapper .header-wrapper .header > h4 {
  color: #333;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.wrapper .header-wrapper .header .header-content {
  color: var(--text-icon-font-gy-190-primary, rgba(0, 0, 0, 0.9));
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 157.143% */
  margin-top: 10px;
}

.wrapper .menu-wrapper {
  height: 54px;
  display: flex;
  padding: 0 calc(50% - 600px);
  background: #2877ff;
  box-shadow: 0 0 10px #ddd;
}

.wrapper .menu-wrapper .menu-list {
  flex: 1;
  font-size: 0;
  min-width: 470px;
  white-space: nowrap;
  position: relative;
}

.wrapper .menu-wrapper .menu-list ::v-deep li {
  display: inline-block;
  line-height: 50px;
  font-size: 15px;
  color: #fff;
  transition: all 0.2s;
  cursor: pointer;
  z-index: 9;
  padding: 0 16px;
}

.wrapper .menu-wrapper .menu-list ::v-deep li.actived {
  background: #005eff;
}

.wrapper .menu-wrapper .right-menu {
  display: flex;
}

.wrapper .menu-wrapper .right-menu .button {
  display: inline-block;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  padding: 0 16px 0 0;
  cursor: pointer;
  line-height: 54px;
}

.wrapper .menu-wrapper .right-menu .button:hover {
  color: rgba(255, 255, 255, 0.8);
}

.wrapper .menu-wrapper .right-menu .round-button {
  display: flex;
  color: #fff;
  padding: 7px 16px;
  margin: 12px 0;
  cursor: pointer;
  border: 1px solid #fff;
  border-radius: 15px;
}

.wrapper .menu-wrapper .right-menu .round-button-disabled {
  color: #999999;
  border: 1px solid #999999;
}

.wrapper .menu-wrapper .right-menu .round-button-disabled > img {
  transform: translateY(-130px);
  filter: drop-shadow(0 130px #999999);
}

.wrapper .menu-wrapper .right-menu .round-button:hover {
  background: #fff;
  color: #2877ff;
}

.wrapper .menu-wrapper .right-menu .round-button:hover > img {
  transform: translateY(-130px);
  filter: drop-shadow(0 130px #2877ff);
}

.wrapper .menu-wrapper .right-menu .round-button > span {
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: 14px;
}

.wrapper .menu-wrapper .right-menu .round-button > img {
  width: 14px;
  height: 14px;
  margin-left: 6px;
}

.wrapper .content-wrapper {
  padding: 0 calc(50% - 600px);
}

.wrapper .content-wrapper .header-box {
  padding: 0 16px;
  background-color: white;
  margin-bottom: 16px;
}

.wrapper .content-wrapper .header-box .download {
  display: flex;
  align-items: center;
  color: #2877ff;
  text-align: center;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  justify-content: space-between;
  font-size: 14px;
  cursor: pointer;
}

.wrapper .content-wrapper .header-box .download > img {
  margin-left: 5px;
  width: 16px;
}

.wrapper .content-wrapper .exam-info {
  display: flex;
  align-items: center;
  margin-left: 15px;

  .exam-name {
    max-width: 400px;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    margin: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .exam-type {
    border-radius: 20px;
    background-color: #ef9a9a;
    color: #ffffff;
    height: 20px;
    line-height: 20px;
    padding: 0 7px;
    font-size: 12px;
  }
}

.wrapper .content-wrapper .exam-info .tool-subject {
  width: 20px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #fff;
  background: url("~images/project.png") no-repeat;
  background-size: 20px 24px;
}

.wrapper .import-grades .dialog-content {
  text-align: center;
  margin-top: 20px;
}

.wrapper .import-grades .dialog-content .import-button {
  width: 200px;
}

.wrapper .import-grades .dialog-content .import-button ::v-deep span {
  display: flex;
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  justify-content: center;
}

.wrapper .import-grades .dialog-content .import-button ::v-deep img {
  margin-right: 4px;
}

.wrapper .import-grades .dialog-footer {
  justify-content: center;
}

.wrapper .import-grades .dialog-footer .upload-button {
  color: #2877ff;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.wrapper .import-grades .dialog-footer .import-btn {
  width: 100px;
}
</style>
<style lang="scss">
.student-answer {
  text-align: center;
}

.student-answer .menu-li {
  display: inline-block;
  color: #333;
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  margin: 5px 0;
  text-align: center;
  cursor: pointer;
  width: 96px;
}

.student-answer .menu-li:hover {
  color: #2877ff;
}

.student-answer .menu-li.disabled {
  color: #999999;
}

.wrapper .menu-wrapper .menu-list .badge .el-badge__content {
  margin-top: 10px;
  margin-right: -10px;
}
</style>